import styled from 'styled-components';
import uniqueId from 'lodash/uniqueId';
import getVideoSrc from '~/helpers/getVideoSrc';
import { ONE_TRUST_COOKIES_CATEGORIES } from '~/providers/CookieShield/CookieShield.helpers';
import CookieShield from '~/providers/CookieShield';

const Wrapper = styled.div`
  position: relative;
  height: 0;
  max-width: 100%;
  padding-top: 56.25%;
  flex-grow: 1;

  iframe {
    height: 100%;
    width: 100%;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

/**
 * @param {VideoProps} props
 * @returns {React.ReactElement} The rendered component
 */
const Video = ({
  videoId,
  cloudName,
  poster = 1,
  provider,
  autoplay = false,
  disableControls = false,
  hash,
  type,
}) => {
  const src = getVideoSrc({
    videoId,
    cloudName,
    poster,
    provider,
    autoplay,
    disableControls,
    hash,
    type,
  });
  return (
    <CookieShield category={ONE_TRUST_COOKIES_CATEGORIES.THIRD_PARTY}>
      <Wrapper>
        {src && (
          <iframe
            title={uniqueId('video_')}
            className={`optanon-category-${ONE_TRUST_COOKIES_CATEGORIES.THIRD_PARTY}`}
            data-src={src}
            src={src}
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
          />
        )}
      </Wrapper>
    </CookieShield>
  );
};

export default Video;
